"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _NotificationFallback = require("./components/NotificationFallback");
var _NotificationSimple = require("./components/NotificationSimple");
var _NotificationWithModal = require("./components/NotificationWithModal");
var _componentsEnum = require("./componentsEnum");
var _actions = require("../../../actions");
var _selectors = require("../../../selectors");
var _AppUpdateTip = _interopRequireDefault(require("../AppUpdateTip"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Notifications = {
  NotificationSimple: _NotificationSimple.NotificationSimple,
  NotificationWithModal: _NotificationWithModal.NotificationWithModal
};
var Notification = exports.Notification = function Notification(_ref) {
  var _Notifications$compon;
  var type = _ref.type,
    message = _ref.message,
    notificationData = _ref.data,
    time = _ref.time,
    idMessage = _ref.idMessage,
    listId = _ref.listId,
    sender = _ref.sender;
  var dispatch = (0, _reactRedux.useDispatch)();
  var roomname = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getCurrentRoomname)(state);
  });
  var notificationType = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getCurrentNotificationType)(state, idMessage);
  });
  if (!isNaN(parseInt(sender))) {
    return null;
  }
  if (!notificationType) {
    dispatch((0, _actions.getNotificationType)(idMessage, roomname, type));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationFallback.NotificationFallback, {
      time: time,
      message: message
    });
  }
  var parsedTokens = JSON.parse(notificationType.tokens);
  var NotificationComponent = (_Notifications$compon = Notifications[_componentsEnum.componentsEnum[notificationType.componentId]]) !== null && _Notifications$compon !== void 0 ? _Notifications$compon : _AppUpdateTip["default"];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationComponent, {
    time: time,
    tokens: parsedTokens,
    message: message,
    notificationData: notificationData,
    type: type,
    idMessage: idMessage,
    listId: listId
  });
};
Notification.proyTypes = {
  type: _propTypes["default"].string,
  message: _propTypes["default"].string,
  data: _propTypes["default"].object,
  time: _propTypes["default"].string,
  idMessage: _propTypes["default"].string,
  listId: _propTypes["default"].string,
  sender: _propTypes["default"].string
};